import { render, staticRenderFns } from "./RestaurantCreate.vue?vue&type=template&id=212839dd&"
import script from "./RestaurantCreate.vue?vue&type=script&lang=js&"
export * from "./RestaurantCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports